import React, { useEffect, useRef, useState } from "react";
import "./table.css";
import styled from "@emotion/styled";
import { suppliedOrderCfaList } from "../../redux/actions/orderActions";
import { useDispatch } from "react-redux";
import moment from "moment";
import CurrentOrdersViewModal from "../modals/order-view-modals/currentOrdersViewModal";
import SuppliedFromCfaViewModal from "../modals/order-view-modals/suppliedFromCfaViewModal";
import UploadInvoiceTableModal from "../modals/uploadInvoiceTableModal";
import CfaUploadInvoiceModal from "../modals/CfaUploadInvoiceModal";
import LoadingSpinnerTable from "../utilites/loader";
import TablePagination from "../Pagination/tablePagination";
import ImageViewModal from "../modals/image-view/image-view-modal";
import searcher from "../../assets/searchInput.svg";

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    maxWidth: "50rem",
    height: "35rem",
    overflowY: "auto",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  }),
);

export const TableFooter = styled("div")(
  {
    background: "#2AD3E7",
    border: "1px solid #e7e5ff",
    borderBottomLeftRadius: " 15px",
    borderBottomRightRadius: "15px",
    maxWidth: "45rem",
    height: "3rem",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  }),
);

const SuppliedOrdersCFA = ({ maxWidth = "100%", location }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [orderListData, setOrderListData] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedOrder, setOrderSelected] = useState(null);
  const [showUploadInvoiceModal, setShowUploadInvoiceModal] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [imageTitleData, setImageTitleData] = useState("");
  const [imageUrlData, setImageUrlData] = useState("");
  const [multiImageUrlData, setMultiImageUrlData] = useState([]);

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const tableRef = useRef(null);
  const isFetching = useRef(false);
  const [paginationData, setPaginationData] = useState({});

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  const ListFnc = () => {
    dispatch(
      suppliedOrderCfaList(
        { page: 1, search: debouncedSearch, page_size: 20 },
        onSuccess,
        onError,
      ),
    );
  };

  useEffect(() => {
    if (location.pathname == "/supplied-order-cfa") {
      setPage(1);
      ListFnc();
      setLoading(true);
    }
  }, [location]);

  useEffect(() => {
    if (location.pathname == "/supplied-order-cfa") {
      setPage(1);
      ListFnc();
      setLoading(true);
    }
  }, [debouncedSearch]);

  const onSuccess = (data) => {
    setLoading(false);
    console.log(data.data.data, "cfa");
    setOrderListData(data.data.data);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const handleScroll = () => {
    if (paginationData.nextPage !== null) {
      const { scrollTop, scrollHeight, clientHeight } = tableRef.current;

      // Check if the user has scrolled to the bottom
      if (scrollTop + clientHeight >= scrollHeight && !isFetching.current) {
        if (paginationData.nextPage !== null) {
          isFetching.current = true; // Set fetching state
          // setLoading(true);
          setPage(page + 1);

          setTimeout(() => {
            dispatch(
              suppliedOrderCfaList(
                { page: page + 1, search: debouncedSearch, page_size: 20 },
                (data) => {
                  onScrollSuccess(data);
                  isFetching.current = false;
                },
                onError,
              ),
            );
          }, 500);
        }
      }
    }
  };

  const onScrollSuccess = (data) => {
    const prevOrders = orderListData?.cfaOrder || [];
    const currentData = data.data.data.cfaOrder;
    const currentPagination = data.data.data.pagination;
    const combinedData = [...prevOrders, ...currentData];

    setOrderListData({ cfaOrder: combinedData, pagination: currentPagination });
    setPaginationData(data.data.data.pagination);
    setLoading(false);
  };

  const compareArray = ["fully_invoiced", "acknowledged"];

  return (
    <div>
      <div
        className="search-container d-flex justify-content-between align-items-center position-sticky top-0 bg-white"
        style={{ zIndex: "10" }}
      >
        <div className="search-box d-flex align-items-center p-1 ms-2 mb-2">
          <img className="styled-SVG" src={searcher} color={""} />
          <input
            className="search-input text-dark fw_400 px-2"
            type="text"
            placeholder="Search Order ID, etc. "
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>
      <TableContainer
        maxWidth={maxWidth}
        ref={tableRef}
        onScroll={handleScroll}
      >
        <table className="main-table fs_10 text-nowrap w-100">
          <thead>
            <tr className="table-rows">
              <th className="main-table-heads" width={"2%"}>
                #
              </th>
              <th className="main-table-heads" width={"7%"}>
                Order ID
              </th>
              <th className="main-table-heads text-nowrap" width={"9%"}>
                Order Date and Time
              </th>
              <th className="main-table-heads text-nowrap" width={"10%"}>
                Doctor Name
              </th>
              <th className="main-table-heads text-nowrap" width={"10%"}>
                Pharmacy Name
              </th>
              <th className="main-table-heads text-nowrap" width={"10%"}>
                Company Name
              </th>
              <th className="main-table-heads text-nowrap" width={"10%"}>
                Division
              </th>
              <th className="main-table-heads text-nowrap" width={"10%"}>
                City
              </th>
              <th className="main-table-heads text-nowrap" width={"10%"}>
                Value Of Order(ex. gst)
              </th>
              <th className="main-table-heads text-nowrap" width={"10%"}>
                Order Status
              </th>
              <th className="main-table-heads text-nowrap" width={"10%"}>
                CFA Invoice Status
              </th>
              <th className="main-table-heads text-nowrap " width={"10%"}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody style={{ position: "relative" }}>
            {loading == true ? (
              <div className="list-spinner-container">
                <LoadingSpinnerTable />
              </div>
            ) : orderListData?.cfaOrder?.length > 0 ? (
              <>
                {orderListData?.cfaOrder?.map((data, index) => (
                  <tr className="table-rows1" key={data?.id}>
                    <td className="main-table-each-row-data">
                      {/* {(currentPage - 1) * 10 + (index + 1)} */}
                      {index + 1}
                    </td>
                    <td className="main-table-each-row-data">
                      {data?.order?.order_id ? data?.order?.order_id : "--"}
                    </td>
                    <td className="main-table-each-row-data">
                      {data?.createdAt
                        ? moment(data?.createdAt)
                            .format("DD MMM YYYY, HH:mm A")
                            .toUpperCase()
                        : "--"}
                    </td>
                    <td className="main-table-each-row-data">
                      {data?.order?.doctor?.name
                        ? data?.order?.doctor?.name
                        : "--"}
                    </td>
                    <td className="main-table-each-row-data">
                      {data?.order?.pharmacy?.pharmacy_name
                        ? data?.order?.pharmacy?.pharmacy_name
                        : "--"}
                    </td>
                    <td className="main-table-each-row-data">
                      {data?.vendor?.name ? data?.vendor?.name : "--"}
                    </td>
                    <td className="main-table-each-row-data">
                      {data?.vendorDivision?.name
                        ? data?.vendorDivision?.name
                        : "--"}
                    </td>
                    <td className="main-table-each-row-data">
                      {data?.city?.name ? data?.city?.name : "--"}
                    </td>
                    <td className="main-table-each-row-data">
                      {data?.ordered_value ? data?.ordered_value : "--"}
                    </td>
                    <td className="main-table-each-row-data">
                      <span
                        className={`${
                          orderStatus.find(
                            (e) => e?.status == data?.order?.status,
                          )?.color
                        }`}
                      >
                        {
                          orderStatus.find(
                            (e) => e?.status == data?.order?.status,
                          )?.value
                        }
                      </span>
                    </td>
                    <td className="main-table-each-row-data">
                      <span
                        className={`${
                          orderStatus.find((e) => e?.status == data?.status)
                            ?.color
                        }`}
                      >
                        {
                          orderStatus.find((e) => e?.status == data?.status)
                            ?.value
                        }
                      </span>
                    </td>
                    <td className="main-table-each-row-data d-flex align-items-center">
                      <span
                        className="color_2ad3e7 fw_700 cursor_pointer"
                        onClick={() => {
                          setOrderSelected(data?.id);
                          setShowDetail(true);
                        }}
                      >
                        VIEW
                      </span>
                      <span className="vr_line mx-1 ms-2 color_b0b3c7"></span>
                      {!compareArray.some(
                        (item) => item == data?.order?.status,
                      ) ? (
                        <button
                          className="text-danger fw_700 mx-1  text-nowrap cursor_pointer action-btn"
                          onClick={() => {
                            setOrderSelected(data?.order_id);
                            setShowUploadInvoiceModal(true);
                          }}
                        >
                          UPLOAD INVOICE
                        </button>
                      ) : (
                        <button
                          className="Medium_Purple fw_600 cursor_pointer action-btn"
                          onClick={() => {
                            setImageModal(true);
                            setImageUrlData(data?.order?.invoices[0]?.url);
                            setMultiImageUrlData(data?.order?.invoices);
                          }}
                        >
                          INVOICE IMAGE
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="1" className="text-center no-data-container fs_16">
                  <span>~ No Data Found ~</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <SuppliedFromCfaViewModal
          ordersViewShow={showDetail}
          showClose={() => setShowDetail(false)}
          id={selectedOrder}
        />
      </TableContainer>
      {/* <div className={loading == true ? `loading-event` : ""}>
        {orderListData?.pagination?.totalPages > 0 && (
          <TablePagination
            data={orderListData?.pagination}
            nextFunc={() => {
              setPage(page + 1);
            }}
            prevFunc={() => {
              setPage(page - 1);
            }}
          />
        )}
      </div> */}
      <UploadInvoiceTableModal
        handleClose={() => setShowUploadInvoiceModal(false)}
        show={showUploadInvoiceModal}
        id={selectedOrder}
        fetchOrderList={ListFnc}
      />
      <ImageViewModal
        show={imageModal}
        ShowClose={() => setImageModal(false)}
        imageTitleData={imageTitleData}
        imageUrlData={imageUrlData}
        muliImageData={multiImageUrlData}
        setImageUrlData={setImageUrlData}
      />
    </div>
  );
};

export default SuppliedOrdersCFA;

export const orderStatus = [
  { status: "pending", value: "Pending", color: "text-warning" },
  { status: "approved", value: "Approved", color: "color_2ad3e7" },
  { status: "fully_invoiced", value: "Fully Invoiced", color: "text_green" },
  {
    status: "partially_invoiced",
    value: "Partially Invoiced",
    color: "Medium_Purple",
  },
  { status: "rejected", value: "Rejected", color: "text-danger" },
  { status: "approval_failed", value: "Approval Failed", color: "text-danger" },
  { status: "cancelled", value: "Cancelled", color: "text-danger" },
  { status: "expired", value: "Expired", color: "text-danger" },
  { status: "acknowledged", value: "Acknowledged", color: "ack_status" },
  {
    status: "partially_acknowledged",
    value: "Partially acknowledged",
    color: "Medium_Purple",
  },
  { status: "hold", value: "Under Process", color: "text-warning" },
];
